import * as React from 'react';
import { ITEM_WIDTH_OVER_XL, ITEM_WIDTH_SP, VerticalListArrows, } from '@lean-body/components/molecules/vertical_list_arrows';
import { LessonComponent, LiveLessonComponent } from '@lean-body/components/molecules';
import { useXlMediaQuery } from '@lean-body/src/util';
export const LessonSessionComponentCarousel = ({ sessions, classObject, itemMarginRight, itemsPadding, addFavoriteLesson, unFavoriteLesson, isMin, disableHistoryPush, }) => {
    const isXL = useXlMediaQuery();
    const addFavorite = (lesson) => {
        lesson.isFavorite = true;
        addFavoriteLesson(lesson.id);
    };
    const unFavorite = (lesson) => {
        lesson.isFavorite = false;
        unFavoriteLesson(lesson.id);
    };
    return (React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: isMin ? ITEM_WIDTH_SP : ITEM_WIDTH_OVER_XL, items: sessions.map((session) => (React.createElement(React.Fragment, null, session.lesson ? (React.createElement(LessonComponent, { lesson: session.lesson, addFavoriteLesson: () => addFavorite(session.lesson), unFavoriteLesson: () => unFavorite(session.lesson), isMin: isMin, disableHistoryPush: disableHistoryPush })) : (React.createElement(LiveLessonComponent, { liveLesson: session.liveLesson, isMin: !isXL, isVertical: false }))))) }));
};
